import { render, staticRenderFns } from "./OrgChartCanvas.vue?vue&type=template&id=c41895c4&scoped=true&"
import script from "./OrgChartCanvas.vue?vue&type=script&lang=js&"
export * from "./OrgChartCanvas.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartCanvas.vue?vue&type=style&index=0&id=c41895c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41895c4",
  null
  
)

export default component.exports